<template>
    <div>
        <div class="max-w-1440">
            <div class="flex justify-center mb-32 relative">
                <steps :steps="tabs" :value="5" container />
            </div>
            <share-job :job="active_job" :new-job="true" :in-setup="true"></share-job>
        </div>

        <div class="absolute right-0 top-96 bg-white shadow-md my-64 rounded-l ml-auto max-h-screen overflow-y-auto z-10 p-48 w-full max-w-640">
            <popup-content :progress="90"
                           :title="$t('free_trial.share.title')"
                           icon="format-list-bulleted"
            ></popup-content>

            <p class="my-8" v-html="flow[flowPosition].description"></p>

            <div class="mt-48 flex justify-center space-x-20">
                <simple-button class="uppercase"
                               look="secondary"
                               @click="$emit('previous')">
                    {{ $t('general.back') }}
                </simple-button>


                <simple-button :loading="loading"
                               class="uppercase"
                               display="secondary"
                               look="primary"
                               @click="handleClick">
                    {{ flow[flowPosition].button }}
                </simple-button>
            </div>
        </div>
    </div>
</template>

<script>
import SimpleButton from '../SimpleButton.vue';
import Job from '../../../models/Job';
import Steps from '../../Steps.vue';
import ShareJob from '../../ShareJob.vue';
import PopupContent from './PopupContent.vue';

export default {
    name: 'VacancyShare',
    components: {PopupContent, ShareJob, Steps, SimpleButton},
    props: {
        active_job: Job,
        selected_flow: Number,
    },
    data() {
        return {
            loading: null,
            flowPosition: 0,
        };
    },
    computed: {
        tabs() {
            return [
                {
                    title: this.$t('jobs.description'),
                    icon: 'description',
                    component: 'job-settings',
                    disabled: true,
                },
                {
                    title: this.$t('jobs.form'),
                    icon: 'list-alt',
                    component: 'form-editor',
                    disabled: true,
                },
                {
                    title: this.$t('jobs.pipeline'),
                    icon: 'conversion-path',
                    component: 'pipeline-editor',
                    disabled: true,
                },
                {
                    title: this.$t('jobs.publish'),
                    icon: 'publish',
                    component: 'publish-job',
                    disabled: true,
                },
                {
                    title: this.$t('applications.share'),
                    icon: 'share',
                    component: 'final',
                    disabled: !this.active_job,
                },
            ];
        },
        flow() {
            return [
                {
                    id: 'social-media',
                    description: this.$t('free_trial.share.step_1.description'),
                    button: this.$t('free_trial.share.step_1.button'),
                },
                {
                    id: 'job-boards',
                    description: this.$t('free_trial.share.step_2.description'),
                    button: this.$t('free_trial.share.step_2.button'),
                },
                {
                    id: 'partners',
                    description: this.$t('free_trial.share.step_3.description'),
                    button: this.$t('free_trial.share.step_3.button'),
                },
                {
                    id: 'partners',
                    description: this.$t('free_trial.share.step_4.description'),
                    button: this.$t('free_trial.share.step_4.button'),
                },
            ];
        },
    },
    methods: {
        handleClick() {
            let newPosition = this.flowPosition;

            this.$emit('setFlow', newPosition);

            if (newPosition === 3) {
                return this.$emit('next', 3);
            }

            // Close all share blocks
            document.querySelectorAll('.accordion-item .accordion-item-body').forEach((item) => {
                item.classList.add('hidden');
            });


            // Open the selected share block
            const targetElement = this.flow[newPosition].id;
            document.getElementById(targetElement).querySelector('.accordion-item-body').classList.remove('hidden');

            this.scrollTo(targetElement);
            this.flowPosition = newPosition + 1;
        },
        scrollTo(id){
            document.getElementById(id).scrollIntoView({behavior: 'smooth'});
        }
    },
    mounted() {
        if (this.selected_flow) {
            this.flowPosition = this.selected_flow;

            this.scrollTo(this.flow[this.selected_flow].id)
        }
    },
};
</script>
